import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { getApprovalOrders } from '../api/approval';
import { orderQueryKeys } from './order';

export const orderApprovalQueryOptions = queryOptions({
	queryKey: orderQueryKeys.approvals(),
	queryFn: ({ signal }) => getApprovalOrders(signal),
	placeholderData: keepPreviousData,
	throwOnError: true,
	retry: false,
	initialDataUpdatedAt: 0,
	initialData: [],
});
